import React from 'react';
import { useEffect, useState } from 'react'

import { CustomerCardModel } from '../models/CustomerCardModel';
import { SimulatorModel } from '../models/SimulatorModel';
import { useSelector, useDispatch } from 'react-redux'
//import '../assets/css/emails.css'
import { Menu } from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'
//import RenewalsManagement from './SystemManagement/_renewalsManagement'
//import './assets/css/systemManagement.css'
import RenewalsManagement from '../SystemManagement/_renewalsManagement'
import '../assets/css/systemManagement.css'
import ProductionAutoUploadManagement from './_productionAutoUploadManagement'
import ProductionFilesManagement from './_productionFilesManagement'


const ProductionManagement = () => {

    const [manualActive, setManualActive] = useState<boolean>(true);
    const [autoActive, setAutoActive] = useState<boolean>(false);
        
    useEffect(() => {

    },
        []);


        const activeProduction = async () => {
                 setManualActive(false);
            setAutoActive(true);
        
            };

            const activeRenewlas = async () => {
                 setManualActive(true);
            setAutoActive(false);
        
            };

       
    // documents end

    return (
<div className='main-content rtl'>
              
              <div className='center-content'>
                <div className='lleads'>
                 <section className="main-body"></section>
<div className="">
            <div className="emails-tab-row">
                <div className={`email-tab email-tab-clients ${manualActive?"selected":""}`}>
                    <div className="top-border" ></div>
                    <div className="tab-content" onClick={()=>activeRenewlas()}><div className="label">ידני</div>
                    </div>
                </div>
                <div className={`email-tab email-tab-view-message ${autoActive?"selected":""}`}>
                    <div className="top-border"></div>
                    <div className="tab-content" onClick={()=>activeProduction()}>
                        <div className="label" >אוטומטי</div>
                        
                    </div>
                </div>
            </div>
        </div>
        <div className='body'>
            {manualActive?<ProductionFilesManagement></ProductionFilesManagement>:""}
            {autoActive?<ProductionAutoUploadManagement></ProductionAutoUploadManagement>:""}
            
        </div>
                  
                  

                </div>
              </div>
              </div>








        

    )
}

export default ProductionManagement;

export {};